import { render, staticRenderFns } from "./other.vue?vue&type=template&id=8c00aecc&scoped=true"
import script from "./other.vue?vue&type=script&lang=ts"
export * from "./other.vue?vue&type=script&lang=ts"
import style0 from "./other.vue?vue&type=style&index=0&id=8c00aecc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c00aecc",
  null
  
)

export default component.exports